/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/search-results/__generated__/searchResultsAsyncQuery.graphql.ts
 */

export const SEARCH_RESULTS_ASYNC_QUERY_PERSISTED_ID = 'bccbdd49d816b372aad6090a955295b76ed70b9fd157d7f9c3b16398d55ae46d';
export const SEARCH_RESULTS_ASYNC_QUERY_OPERATION_NAME = 'searchResultsAsyncQuery';
